import React, { Component } from 'react';
import T from 'prop-types';
import { Select, TextInput, Grid, Column } from '@acast/decibel';
import Field from 'shared/components/field';
import createEmbedCodeFromLayout from './createEmbedCodeFromLayout';

const LAYOUTS = [
  { layoutName: 'Horizontal', sizeName: 'Default (188px)', sizeValue: 188 },
  { layoutName: 'Horizontal', sizeName: 'Slim (80px)', sizeValue: 80 },

  { layoutName: 'Square', sizeName: 'Default (400px)', sizeValue: 400 },
  { layoutName: 'Square', sizeName: 'Medium (512px)', sizeValue: 512 },
  { layoutName: 'Square', sizeName: 'Large (960px)', sizeValue: 960 },
];

const getUniqueLayoutNames = layouts =>
  layouts.reduce((acc, l) => {
    return acc.find(name => name === l.layoutName) ? acc : [...acc, l.layoutName];
  }, []);

export class EmbedCodeGenerator extends Component {
  static propTypes = {
    layouts: T.arrayOf(
      T.shape({
        layoutName: T.string.isRequired,
        sizeName: T.string.isRequired,
        sizeValue: T.number.isRequired,
      })
    ).isRequired,
    showSlug: T.string.isRequired,
    episodeSlug: T.string,
  };

  static defaultProps = {
    layouts: LAYOUTS,
  };

  constructor(props, ...rest) {
    super(props, ...rest);

    this.state = {
      selectedEmbedLayout: props.layouts[0],
    };
  }

  handleSelectEmbedLayout = selectedLayoutName => {
    this.setState({
      selectedEmbedLayout: this.props.layouts.find(
        ({ layoutName }) => layoutName === selectedLayoutName
      ),
    });
  };

  handleSelectEmbedSize = selectedLayoutName => selectedSizeName => {
    this.setState({
      selectedEmbedLayout: this.props.layouts.find(
        ({ layoutName, sizeName }) =>
          layoutName === selectedLayoutName && sizeName === selectedSizeName
      ),
    });
  };

  render() {
    const { showSlug, episodeSlug, layouts } = this.props;
    const { selectedEmbedLayout } = this.state;

    const embedCode = createEmbedCodeFromLayout({
      layout: selectedEmbedLayout,
      showSlug,
      episodeSlug,
    });

    const layoutOptions = getUniqueLayoutNames(layouts).map(name => ({
      value: name,
      label: name,
    }));

    const sizeOptions = layouts
      .filter(({ layoutName }) => layoutName === selectedEmbedLayout.layoutName)
      .map(({ sizeName }) => ({ label: sizeName, value: sizeName }));

    return (
      <Grid>
        <Column width="50%">
          <Field name="embedded-player-layout" label="Layout" help="Layout of the embed player.">
            <Select
              value={selectedEmbedLayout.layoutName}
              onChange={event => this.handleSelectEmbedLayout(event.target.value)}
            >
              {layoutOptions.map(option => (
                <Select.Option key={option.value} value={option.value} disabled={option.disabled}>
                  {option.label}
                </Select.Option>
              ))}
            </Select>
          </Field>
        </Column>

        <Column width="50%">
          <Field
            name="embedded-player-size"
            label="Player Size"
            help="Size in pixels of the embed player."
          >
            <Select
              value={selectedEmbedLayout.sizeName}
              onChange={event =>
                this.handleSelectEmbedSize(selectedEmbedLayout.layoutName)(event.target.value)
              }
            >
              {sizeOptions.map(option => (
                <Select.Option key={option.value} value={option.value} disabled={option.disabled}>
                  {option.label}
                </Select.Option>
              ))}
            </Select>
          </Field>
        </Column>

        <Column>
          <Field
            name="embedded-player-code"
            label="Embed Code"
            help="The HTML code used to embed the Acast player on your website. This player will always show the latest episode of your show."
          >
            <TextInput readOnly value={embedCode || 'Embed code is not available'} />
          </Field>
        </Column>
      </Grid>
    );
  }
}

export default EmbedCodeGenerator;
